import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllGroup = async (clientId?: number) => {
    // Explicitly handle null, undefined, 0, and NaN cases
    const url = (clientId != null && !isNaN(clientId) && clientId !== 0) ? `/campaigngroup/all?clientId=${clientId}` : '/campaigngroup/all';
    // Send the GET request
    const response = await http.get(url);
    // Return the response
    return response;
}


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllGroupById = async (id?: number) => {
    const response = http.get(`/campaigngroup/${id !== undefined ? id : ''}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const addGroup = async (data: any) => {
    const response = http.post(`/campaigngroup/add`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const deleteGroup= async (data: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const response = http.post(`/campaigngroup/delete`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const activatedeactivate = async (data: any) => {
    const response = http.post(`/campaigngroup/deactivate`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const updateGroup = async (data: any) => {
    const response = http.put(`/campaigngroup/update`, data)
    return response;
}
